import { useContext, useEffect } from "react";
import { AuthContext } from "../store/auth-context";
import { useSelector } from "react-redux";
import { Actions } from "../redux/constants/actionTypes";
import { getStore } from "../Utils/storeUtils";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";

import {
  OrganizationDashboardRoutesList,
  OrganizationOverviewRoutes,
} from "./routes";

const PrivateRoutes = () => {
  const authCtx = useContext(AuthContext);
  let loggedInUserInfo = useSelector((state) => state.users.userInfo);
  const navigate = useNavigate();
  const location = useLocation();

  const currentUserDetails = authCtx.currentUser;

  if (!loggedInUserInfo && currentUserDetails) {
    let sessionUser = currentUserDetails?.tokens?.idToken?.payload;
    getStore().dispatch({
      type: Actions.LOGIN_USER,
      userInfo: sessionUser ? sessionUser : null,
    });
  }

  const dashboardList = OrganizationDashboardRoutesList;
  const organizationOverviewList = OrganizationOverviewRoutes;

  useEffect(() => {
    const paths = ["/login", "/register", "/forgot", "/verify", "/new-signup"];
    const checkAuthentication = async () => {
      try {
        const authenticated = await authCtx.userfetch();
        if (!authenticated && !paths.includes(location.pathname)) {
          await authCtx.logout();
          navigate("/login");
        }
      } catch (_) {
        if (!paths.includes(location.pathname)) {
          navigate("/login");
        }
      }
    };
    checkAuthentication();
  }, []);

  // Google Tag Setup for page_view
  useEffect(() => {
    window.dataLayer.push({
      event: "page_view",
      page: {
        url: location.pathname,
        title: document.title,
      },
    });
  }, [location.pathname]);

  const getRoutes = () => {
    return (
      <Routes>
        {dashboardList.map((value, index) => {
          return (
            <Route
              key={index}
              path={value.path}
              element={<value.layout component={value.component} />}
            />
          );
        })}
        {organizationOverviewList.map((value, index) => {
          return (
            <Route
              key={index}
              path={value.path}
              element={<value.layout component={value.component} />}
            />
          );
        })}
        {/* 404 page should be here <Route path="*" element={<OrganizationOverview />} /> */}
      </Routes>
    );
  };

  return <>{getRoutes()}</>;
};

export default PrivateRoutes;
